// // firebase.js
// import { initializeApp } from "firebase/app";
// import {
//   getRemoteConfig,
//   fetchAndActivate,
//   getValue,
// } from "firebase/remote-config";
// import { getMessaging, getToken } from "firebase/messaging";

// // Your Firebase config (from Firebase console > Project settings)
// const firebaseConfig = {
//   apiKey: "AIzaSyCU5nxxSFoI_ljlIR5QNux5wh__FKILJno",
//   authDomain: "team-bigfoot.firebaseapp.com",
//   databaseURL: "https://team-bigfoot-default-rtdb.firebaseio.com",
//   projectId: "team-bigfoot",
//   storageBucket: "team-bigfoot.firebasestorage.app",
//   messagingSenderId: "625516275504",
//   appId: "1:625516275504:web:e6ec41d12f7bc868700af5",
//   measurementId: "G-VR828YMGBE",
// };

// const vapidKey =
//   "BBns7xVeAmFhOrCz6CcM76lEj57Q8GuXsTmxjAeuFabhbKvU3S_GAmM6PimIfnn22qo8nO16-X2HYmW3bDO8JpM";

// export const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);

// // Remote Config setup
// const remoteConfig = getRemoteConfig(app);
// // Optional: define minimum fetch interval for dev (avoid cache delays)
// remoteConfig.settings = { minimumFetchIntervalMillis: 0 };
// // Default values
// remoteConfig.defaultConfig = {
//   is_drive_maintenance: false,
//   drive_max_file_size: 50,
//   drive_select_file_limit: 5,
//   default_country: "",
//   country: "",
//   language: "",
//   color: "",
//   report_mail_reason: "",
// };

// const requestFCMToken = async () => {
//   return Notification.requestPermission()
//     .then((permission) => {
//       if (permission === "granted") {
//         return getToken(messaging, { vapidKey });
//       } else {
//         throw new Error("Notification Not granted");
//       }
//     })
//     .catch((err) => {
//       console.error("Error getting FCM Token: ", err);
//       throw err;
//     });
// };

// export { remoteConfig, requestFCMToken, fetchAndActivate, getValue };

import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyCU5nxxSFoI_ljlIR5QNux5wh__FKILJno",
  authDomain: "team-bigfoot.firebaseapp.com",
  databaseURL: "https://team-bigfoot-default-rtdb.firebaseio.com",
  projectId: "team-bigfoot",
  storageBucket: "team-bigfoot.firebasestorage.app",
  messagingSenderId: "625516275504",
  appId: "1:625516275504:web:e6ec41d12f7bc868700af5",
  measurementId: "G-VR828YMGBE",
};

const app = initializeApp(firebaseConfig);

export const remoteConfig = getRemoteConfig(app);

remoteConfig.settings = { minimumFetchIntervalMillis: 0 };

remoteConfig.defaultConfig = {
  is_drive_maintenance: false,
  max_file_size: 1,
  max_report_image_limit: 1,
  drive_max_file_size: 50,
  drive_select_file_limit: 5,
  default_country: "",
  country: "",
  language: "",
  color: "",
  emoji: "",
  report_mail_reason: "",
  default_language: "",
  trash_cleanup_day: "",
};

export default app;
